export interface IOTPSchema {
    isValid: boolean;
}
